export const SET_CONTENT = 'rpb2b-react/ar-summary/SET_CONTENT';
export type SET_CONTENT = typeof SET_CONTENT;

export const GET_AR_SUMMARY_IS_PENDING =
  'rpb2b-react/ar-summary/GET_AR_SUMMARY_IS_PENDING';
export type GET_AR_SUMMARY_IS_PENDING = typeof GET_AR_SUMMARY_IS_PENDING;

export const CLEAR_ALL = 'rpb2b-react/ar-summary/CLEAR_ALL';
export type CLEAR_ALL = typeof CLEAR_ALL;

export const AR_SUMMARY_ERROR = 'rpb2b-react/ar-summary/AR_SUMMARY_ERROR';
export type AR_SUMMARY_ERROR = typeof AR_SUMMARY_ERROR;

export default {
  SET_CONTENT,
  GET_AR_SUMMARY_IS_PENDING,
  CLEAR_ALL,
  AR_SUMMARY_ERROR
};
